import {
  Button,
  Checkbox,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import { AddCircle, DragIndicator, MoreHoriz, RemoveCircle } from '@material-ui/icons';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import VisibilityIcon from '@material-ui/icons/Visibility';
import React, { useEffect } from 'react';
import { IN_ROOM_DINING_CUSTOMISATIONS_EDIT } from '../../../../../constants/InRoomDiningConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../../../constants/RoleConsts';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import { PARTIAL_CHECKBOX_GREEN, updateSelectedModule } from '../../../../../utils/formUtils';
import BulkActionCheckBox from '../../../../../shared/MultiActionPopUp/BulkActionCheckBox';

const InRoomDiningCustomisationTable = (props) => {
  const {
    page,
    dragDisabled,
    rowsPerPage,
    onOpenDrawer,
    selectedValue,
    handleClose,
    handleCellMenuClick,
    customisations,
    setCustomisations,
    onViewDetails,
    onClickRowViewDetails,
    handleChangePage,
    handleChangeRowsPerPage,
    onDeleteCustomisation,
    onActiveDeActiveonDeleteCustomisation,
    permissions,
    setVisible,
    handleSelectAll,
    isAllSelected,
    setIsAllSelected,
    handleCheckboxChange,
    setActionMenuList,
    inRoomDiningCustomisations,
    selectedCustomisationLength,
  } = props;

  useEffect(() => {
    updateSelectedModule(customisations, setActionMenuList, setIsAllSelected);
  }, [customisations]);

  return (
    <TableContainer>
      <Table className='list-table' aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
              <BulkActionCheckBox
                onChange={handleSelectAll}
                checked={isAllSelected || false}
                selectedLength={selectedCustomisationLength}
                totalLength={inRoomDiningCustomisations?.length}
                inputProps={{
                  'aria-label': 'select all Customisations',
                }}
                className={PARTIAL_CHECKBOX_GREEN}
              />
            </TableCell>
            <TableCell className='w-40'>Name</TableCell>
            <TableCell className='w-40'>Code</TableCell>
            <TableCell className='w-40' align='center'>
              Status
            </TableCell>
            <TableCell align='right'></TableCell>
          </TableRow>
        </TableHead>

        <DragDropContext
          onDragEnd={(event) =>
            handleOnDragEnd(
              event,
              setVisible,
              customisations,
              setCustomisations,
              false,
              page,
              rowsPerPage,
            )
          }
          isDropDisabled={dragDisabled}
        >
          <Droppable droppableId='services' isDropDisabled={dragDisabled}>
            {(provided) => (
              <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                {(rowsPerPage > 0
                  ? customisations.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : customisations
                ).map((cust, key) => (
                  <Draggable
                    key={cust.id}
                    draggableId={cust.id}
                    index={key}
                    isDragDisabled={dragDisabled}
                  >
                    {(provided) => (
                      <TableRow
                        key={key}
                        className='border-white pointer'
                        onClick={(e) => {
                          onClickRowViewDetails(cust, e);
                        }}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <TableCell className='w-12'>
                          {!dragDisabled && (
                            <span style={{ marginRight: 1.5 }}>
                              <DragIndicator className='res-menu-accordion-drag' />
                            </span>
                          )}
                          <Checkbox
                            onChange={(event) => handleCheckboxChange(cust?.id)}
                            checked={cust?.isChecked || false}
                            inputProps={{
                              'aria-label': `select customisation ${cust?.id}`,
                            }}
                          />
                        </TableCell>
                        <TableCell className='w-40'>{cust?.name}</TableCell>
                        <TableCell className='w-40'>{cust?.code}</TableCell>
                        <TableCell className='w-40'>
                          <div className='d-flex justify-content-center'>
                            <div
                              className={`${cust?.status ? 'pill-active ' : 'pill-inactive '} 
                              pill d-flex justify-content-center align-items-center`}
                            >
                              <span className='ms-1'>{!cust?.status ? 'Inactive' : 'Active'}</span>
                            </div>
                          </div>
                        </TableCell>
                        <TableCell align='right'>
                          {permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] ===
                            RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                            <Button
                              aria-controls='simple-menu'
                              aria-haspopup='true'
                              onClick={(e) => {
                                handleCellMenuClick(e, cust);
                              }}
                              className='showpopupInner'
                            >
                              <MoreHoriz className='showpopupInner' />
                            </Button>
                          )}
                          <Menu
                            id={key}
                            anchorEl={selectedValue?.anchorEl}
                            disableRestoreFocus
                            MenuListProps={{ autoFocusItem: false }}
                            keepMounted
                            open={Boolean(selectedValue.anchorEl) && selectedValue.id === cust.id}
                            onClose={handleClose}
                            className='shadow'
                          >
                            <MenuItem
                              className='pe-4'
                              onClick={(e) =>
                                onActiveDeActiveonDeleteCustomisation(
                                  e,
                                  selectedValue?.customisation?.status ? 'deactivate' : 'active',
                                )
                              }
                            >
                              {selectedValue?.customisation?.status ? (
                                <>
                                  <RemoveCircle className='me-2 action-menu-icon' />
                                  Deactivate
                                </>
                              ) : (
                                <>
                                  <AddCircle className='me-2 action-menu-icon' />
                                  Activate
                                </>
                              )}
                            </MenuItem>

                            <MenuItem
                              className='pe-4'
                              onClick={(e) => onOpenDrawer(e, IN_ROOM_DINING_CUSTOMISATIONS_EDIT)}
                            >
                              <CreateIcon className='me-2 action-menu-icon' />
                              Edit
                            </MenuItem>
                            <MenuItem className='pe-4' onClick={(e) => onViewDetails(cust, e)}>
                              <VisibilityIcon className='me-2 action-menu-icon' />
                              View
                            </MenuItem>
                            <MenuItem className='pe-4' onClick={(e) => onDeleteCustomisation(e)}>
                              <DeleteForeverIcon className='me-2 action-menu-icon' />
                              Delete
                            </MenuItem>
                          </Menu>
                        </TableCell>
                      </TableRow>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </TableBody>
            )}
          </Droppable>
        </DragDropContext>
        <TableFooter>
          <TableRow className='paginator'>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              count={customisations.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default InRoomDiningCustomisationTable;
